import React from 'react'
import './Projects.css'

function Projects() {
    return (
        <div className='projects'>
            <h1>Projects here...</h1>
        </div>
    )
}

export default Projects
